import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { procurementApi } from '../../api/procurement';

export function ProcurementAnalyticsPage() {
  const [analytics, setAnalytics] = useState<{ total_spend: number; avg_lead_time_days: number; budget_variance: number } | null>(null);
  const [intel, setIntel] = useState<{ health_score: number; recommendations: string[] } | null>(null);

  useEffect(() => {
    void procurementApi.analytics().then(setAnalytics);
    void procurementApi.intelligence().then(setIntel);
  }, []);

  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/procurement" className="text-sm text-slate-600 hover:underline">← Procurement hub</Link>
      <h1 className="mt-2 text-2xl font-semibold">Procurement analytics</h1>
      {analytics && (
        <div className="mt-6 grid gap-4 sm:grid-cols-3">
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Total spend</p><p className="text-xl font-semibold">₹{analytics.total_spend.toFixed(0)}</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Avg lead time</p><p className="text-xl font-semibold">{analytics.avg_lead_time_days.toFixed(1)} days</p></div>
          <div className="rounded-xl border p-4"><p className="text-sm text-slate-500">Budget variance</p><p className="text-xl font-semibold">₹{analytics.budget_variance.toFixed(0)}</p></div>
        </div>
      )}
      {intel && (
        <div className="mt-6 rounded-xl border p-4">
          <p className="text-sm text-slate-500">AI health score</p>
          <p className="text-xl font-semibold">{(intel.health_score * 100).toFixed(0)}%</p>
          <ul className="mt-2 list-disc pl-5 text-sm text-slate-600">
            {intel.recommendations.map((r) => <li key={r}>{r}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
